<template>
  <div class="page">
    <div class="main">
      <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

      <div class="submitted" v-if="!loading && submitted">
        <img class="icon-success" src="https://static.huiyiji520.com/success-1692046533.png">
        <div>机长报名表已提交，等待审核</div>
      </div>

      <div class="unsubmit" v-if="!loading && !submitted">

        <div class="question">
          <div class="q-header"><span class="star">*</span> 01 自我介绍 / 自我评价</div>
          <van-field
            class="q-input"
            v-model="introduction"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写自我介绍/自我评价"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 02 教育经历</div>
          <van-field
            class="q-input"
            v-model="education"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写教育经历"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 03 实践经历</div>
          <van-field
            class="q-input"
            v-model="practice"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写实践经历"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 04 特长/技能/兴趣爱好</div>
          <van-field
            class="q-input"
            v-model="hobby"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写特长/技能/兴趣爱好"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 05 对浪漫员3天CP活动的了解与认识</div>
          <van-field
            class="q-input"
            v-model="understanding"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写对浪漫员3天CP活动的了解与认识"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 06 对浪漫员3天CP活动有哪些建议</div>
          <van-field
            class="q-input"
            v-model="advice"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写对浪漫员3天CP活动有哪些建议"
            show-word-limit
          />
        </div>

        <div class="question">
          <div class="q-header"><span class="star">*</span> 07 为什么想当机长</div>
          <van-field
            class="q-input"
            v-model="reason"
            rows="3"
            autosize
            type="textarea"
            placeholder="请填写为什么想当机长"
            show-word-limit
          />
        </div>

        <div class="btn-submit" @click="submitForm">提交</div>

      </div>
    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading, Field} from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Field.name]: Field
  },
  data(){
    return {
      openid: "",
      introduction: "",
      education: "",
      practice: "",
      hobby: "",
      understanding: "",
      advice: "",
      reason: "",
      loading: true,
      submitted: false
    }
  },
  methods: {
    getSubmitHistory(){
      let openid = this.$store.state.userinfo.openid
      // Toast(`openid: ${openid}`)
      this.$api.get('/captain/check_submit_history', {openid: openid}, res => {
        if(res.code == 200){
          this.loading = false
          this.submitted = res.submitted
        }
      })
    },
    submitForm(){
      if(this.introduction.trim().length == 0){
        Toast('请填写自我介绍/自我评价')
        return;
      }
      if(this.education.trim().length == 0){
        Toast('请填写教育经历')
        return;
      }
      if(this.practice.trim().length == 0){
        Toast('请填写实践经历')
        return;
      }
      if(this.hobby.trim().length == 0){
        Toast('请填写特长/技能/兴趣爱好')
        return;
      }
      if(this.understanding.trim().length == 0){
        Toast('请填写对浪漫员3天CP活动的了解与认识')
        return;
      }
      if(this.advice.trim().length == 0){
        Toast('请填写对浪漫员3天CP活动有哪些建议')
        return;
      }
      if(this.reason.trim().length == 0){
        Toast('请填写为什么想当机长')
        return;
      }

      this.loading = true
      let openid = this.$store.state.userinfo.openid
      this.$api.post('/captain/submit_captain_form', {
        openid: openid, introduction: this.introduction, education: this.education, practice: this.practice,
        hobby: this.hobby, understanding: this.understanding, advice: this.advice, reason: this.reason
      }, res => {
        if(res.code == 200){
          this.loading = false
          this.submitted = true
        }else{
          Toast('网络异常，请稍后再试～')
        }
      })

    }
  },
  mounted(){
    this.getSubmitHistory()
  }
}
</script>

<style scoped>
.page{
  min-height:100vh;
  background-color: #f8f8f8;
  padding:20px;
  width: 100%;
  height: 100%;
}
.loading{margin-top:30%;}
.submitted{padding-top:30%;font-size:40px;}
.submitted .icon-success{width:150px;height:150px;margin:0px auto;margin-bottom:50px;}
.unsubmit{padding-top:50px;padding-bottom:70px;}
.unsubmit .question{text-align:left;margin-bottom:70px;}
.unsubmit .question .q-header{font-size:32px;margin-bottom:20px;}
.unsubmit .question .q-header .star{color:#dd4b39;}
.unsubmit .question .q-input{border-radius:10px;}
.unsubmit .btn-submit{background:#0f88eb;color:#fff;font-size:32px;height:80px;line-height:80px;border-radius:10px;}
</style>
